var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2999 4.50011C14.9999 -0.0998869 8.4999 -1.19989 3.8999 2.20011C2.6999 3.10011 1.6999 4.30011 0.899902 5.60011C1.0999 6.00011 1.3999 6.40011 1.6999 6.80011C4.9999 11.4001 11.2999 12.4001 15.8999 9.20011C16.7999 8.50011 17.5999 7.80011 18.2999 6.80011C18.5999 6.40011 18.7999 6.00011 19.0999 5.60011C18.7999 5.20011 18.5999 4.80011 18.2999 4.50011ZM10.0999 2.20011C10.5999 1.70011 11.3999 1.70011 11.8999 2.20011C12.3999 2.70011 12.3999 3.50011 11.8999 4.00011C11.3999 4.50011 10.5999 4.50011 10.0999 4.00011C9.5999 3.50011 9.5999 2.70011 10.0999 2.20011ZM9.9999 9.90011C6.8999 9.90011 3.9999 8.30011 2.2999 5.70011C3.4999 4.00011 5.0999 2.80011 6.9999 2.20011C6.2999 3.00011 5.9999 3.90011 5.9999 4.90011C5.9999 7.10011 7.6999 9.00011 9.9999 9.00011C12.1999 9.00011 14.0999 7.30011 14.0999 5.00011V4.90011C14.0999 3.90011 13.6999 2.90011 12.9999 2.20011C14.8999 2.80011 16.4999 4.00011 17.6999 5.70011C15.9999 8.30011 13.0999 9.90011 9.9999 9.90011Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.4dc27a99c168092d8c24ba138d97da38.svg";
export { ForwardRef as ReactComponent };